export const FLEXPORT_TRACKING_PREFIX = "FLEX-";
export const FLEXPORT_TRACKING_URL = "https://app.flexport.com/shipments/";
export const FLEXPORT_CARRIER_CODE = "FLXT";
